<template>
  <footer class="footer">
    <div class="footer-content">
      <!-- 联系信息区域 -->
      <div class="contact-section">
        <div class="contact-row">
          <div class="contact-item">
            <i class="fas fa-phone"></i>
            <span>联系电话：<a href="tel:15338885501" class="phone-link">15338885501 谢总</a></span>
          </div>
          <div class="contact-item">
            <i class="fas fa-map-marker-alt"></i>
            <span>地址：深圳市南山区南头街道中山南街33栋3层</span>
          </div>
        </div>
        <div class="contact-row">
          <div class="contact-item">
            <i class="fas fa-clock"></i>
            <span>工作日：9:00-18:00</span>
          </div>
          <div class="contact-item wechat-item">
            <i class="fab fa-weixin"></i>
            <span>微信公众号：连平万绿佳品商贸中心</span>
            <div class="wechat-qr">
              <img src="@/assets/images/gzh.jpg" alt="万绿佳品微信公众号二维码" class="qr-image">
            </div>
          </div>
        </div>
        <div class="contact-row shop-row">
          <div class="contact-item baidu-item">
            <i class="fas fa-store"></i>
            <span>百度旗舰店:万绿佳品</span>
            <div class="wechat-qr">
              <img src="@/assets/images/bddp.png" alt="百度店铺二维码" class="qr-image">
            </div>
          </div>
          <div class="contact-item jd-item">
            <i class="fas fa-store"></i>
            <a
              href="http://mall.jd.com/index-270595261.html"
              target="_blank"
              rel="noopener noreferrer"
              class="shop-link"
            >京东旗舰店:万绿佳品</a>
            <div class="wechat-qr">
              <img src="@/assets/images/jd.jpg" alt="京东店铺二维码" class="qr-image">
            </div>
          </div>
          <div class="contact-item taobao-item">
            <i class="fas fa-store"></i>
            <span>淘宝企业店:万绿佳品</span>
            <div class="wechat-qr">
              <img src="@/assets/images/dp.jpg" alt="淘宝店铺二维码" class="qr-image">
            </div>
          </div>
          <div class="contact-item miniprogram-item">
            <i class="fas fa-store"></i>
            <span>抖音旗舰店:万绿佳品</span>
            <div class="wechat-qr">
              <img src="@/assets/images/douyin.png" alt="抖音店铺二维码" class="qr-image">
            </div>
          </div>
        </div>
        <div class="contact-row">
          <div class="contact-item">
            <i class="fas fa-envelope"></i>
            <span>客服中心：<a href="mailto:service@wanlvjiapin.com" class="email-link">service@wanlvjiapin.com</a></span>
          </div>
        </div>
      </div>

      <!-- 品牌理念 -->
      <div class="brand-concept">
        <p class="concept-text">绿色 · 创新 · 卓越 · 务实</p>
      </div>

      <!-- 分隔线 -->
      <div class="separator"></div>

      <!-- 备案信息 -->
      <div class="beian-section">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link" rel="noopener noreferrer">
          <i class="fas fa-shield-alt beian-icon"></i>
          粤ICP备2025488334号
        </a>
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002011782"
          target="_blank"
          class="beian-link gongan-beian"
          rel="noopener noreferrer"
        >
          <img src="@/assets/images/wangbei.png" alt="备案" class="beian-icon">
          公安备案：粤公网安备44030002011782号
        </a>
      </div>

      <!-- 版权信息 -->
      <div class="copyright-section">
        <p class="copyright-text">版权所有 © 2026 深圳市万绿佳品科技有限公司</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    goToTbook() {
      // 跳转到留言板页面
      this.$router.push('/tbook');
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, rgba(46, 139, 87, 0.05), rgba(255, 255, 255, 0.9));
  padding: 2rem 0 0rem 0;
  margin-top: auto;
  border-top: 1px solid rgba(46, 139, 87, 0.1);
  position: relative;
  z-index: 1000;
}

.footer-content {
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}


/* 联系信息区域 */
.contact-section {
  margin-bottom: 1.5rem;
}

.contact-row {
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.shop-row {
  /* 让“百度/淘宝/小程序”在桌面端显示为同一行 */
  flex-wrap: nowrap;
}

/* 桌面端店铺项图标在文字上方 */
.shop-row .contact-item {
  flex-direction: column;
  gap: 0.35rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4a4a4a;
  font-size: 0.9rem;
  min-width: 200px;
  pointer-events: auto;
}

.contact-item i {
  color: #2e8b57;
  font-size: 1rem;
  width: 16px;
  text-align: center;
}

/* 微信公众号二维码样式 */
.wechat-item {
  position: relative;
  cursor: pointer;
}

.wechat-item span {
  color: #2e8b57;
  font-weight: 600;
}

/* 微信小程序二维码样式 */
.miniprogram-item {
  position: relative;
  cursor: pointer;
}

.miniprogram-item span {
  color: #2e8b57;
  font-weight: 600;
}

/* 百度店铺二维码样式 */
.baidu-item {
  position: relative;
  cursor: pointer;
}

.baidu-item span {
  color: #2e8b57;
  font-weight: 600;
}

/* 京东店铺样式 */
.jd-item {
  position: relative;
  cursor: pointer;
}

.jd-item a {
  color: #2e8b57;
  font-weight: 600;
}

/* 统一店铺名称点击样式（京东/百度/淘宝/抖音等） */
.shop-link {
  color: #2e8b57;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.shop-link:hover {
  color: #2e8b57;
  text-decoration: underline;
}

/* 淘宝店铺样式 */
.taobao-item {
  position: relative;
  cursor: pointer;
}

.taobao-item span {
  color: #2e8b57;
  font-weight: 600;
}

.wechat-qr {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 10px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  background: white;
  padding: 3px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(46, 139, 87, 0.8);
  width: 126px;
  height: 126px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wechat-item:hover .wechat-qr {
  opacity: 1;
  visibility: visible;
}

.miniprogram-item:hover .wechat-qr {
  opacity: 1;
  visibility: visible;
}

.baidu-item:hover .wechat-qr {
  opacity: 1;
  visibility: visible;
}

.jd-item:hover .wechat-qr {
  opacity: 1;
  visibility: visible;
}

.taobao-item:hover .wechat-qr {
  opacity: 1;
  visibility: visible;
}

.qr-image {
  width: auto;
  height: auto;
  max-width: 120px;
  max-height: 120px;
  display: block;
  border-radius: 4px;
  object-fit: contain;
  background: white;
}

.phone-link {
  color: #2e8b57;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
  cursor: pointer;
  pointer-events: auto;
}

.phone-link:hover {
  color: #2e8b57;
  text-decoration: underline;
}

.email-link {
  color: #2e8b57;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
  cursor: pointer;
  pointer-events: auto;
}

.email-link:hover {
  color: #2e8b57;
  text-decoration: underline;
}

/* 品牌理念 */
.brand-concept {
  margin: 0.5rem 0;
  padding: 0;
}

.concept-text {
  color: #2e8b57;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.5px;
  position: relative;
  display: inline-block;
  padding: 0.4rem 1.2rem;
  background: linear-gradient(135deg, rgba(46, 139, 87, 0.05), rgba(46, 139, 87, 0.1));
  border-radius: 25px;
  border: 1px solid rgba(46, 139, 87, 0.2);
  transition: all 0.3s ease;
}

.concept-text:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(46, 139, 87, 0.15);
  background: linear-gradient(135deg, rgba(46, 139, 87, 0.1), rgba(46, 139, 87, 0.15));
}

/* 分隔线 */
.separator {
  width: 60%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d0d0d0, transparent);
  margin: 1rem auto;
}

/* 备案信息区域 */
.beian-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0 0 0.5rem 0;
  position: relative;
  z-index: 10;
}

.beian-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #888;
  text-decoration: none;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  background: linear-gradient(135deg, rgba(46, 139, 87, 0.05), rgba(46, 139, 87, 0.1));
  border: 1px solid rgba(46, 139, 87, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  user-select: none;
}

.beian-link:hover {
  color: #2e8b57;
  background: linear-gradient(135deg, rgba(46, 139, 87, 0.1), rgba(46, 139, 87, 0.15));
  border-color: rgba(46, 139, 87, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(46, 139, 87, 0.15);
}

.beian-link:active {
  transform: translateY(0);
}

.beian-icon {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
  opacity: 0.7;
}

.beian-font-icon {
  width: auto;
  height: auto;
  display: inline-block;
  font-size: 0.8rem;
  color: #2e8b57;
}

.beian-link:hover .beian-icon {
  opacity: 1;
}

/* 版权信息区域 */
.copyright-section {
  padding: 0.5rem 0 1rem 0;
}

.copyright-text {
  color: #666;
  font-size: 0.85rem;
  margin: 0;
  letter-spacing: 0.5px;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.copyright-text:hover {
  color: #2e8b57;
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer {
    padding: 1.5rem 0 1rem 0;
  }

  .contact-section {
    margin-bottom: 0.8rem;
  }

  .brand-concept {
    margin: 0.3rem 0;
  }

  .contact-row {
    flex-direction: column;
    gap: 0.8rem;
    align-items: center;
  }

  .shop-row {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    column-gap: 1rem;
    row-gap: 0.7rem;
    width: auto;
    max-width: none;
    justify-content: center;
    align-items: center;
  }

  .shop-row .contact-item {
    min-width: 0;
    width: auto;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: center;
  }

  .contact-item {
    min-width: auto;
    justify-content: center;
    font-size: 0.85rem;
  }

  .separator {
    width: 80%;
    margin: 1rem auto 0 auto;
  }

  .concept-text {
    font-size: 1rem;
    padding: 0.3rem 1rem;
    letter-spacing: 0.3px;
  }

  .beian-link {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }

  .copyright-section {
    padding: 0.3rem 0 0.8rem 0;
  }

  .copyright-text {
    font-size: 0.8rem;
    letter-spacing: 0.3px;
  }
}

@media (max-width: 480px) {
  .footer-content {
    padding: 0 0.5rem;
  }

  .contact-section {
    margin-bottom: 0.5rem;
  }

  .brand-concept {
    margin: 0.2rem 0;
  }

  .contact-item {
    font-size: 0.8rem;
  }

  .contact-item i {
    font-size: 0.9rem;
  }

  /* 移动端微信公众号二维码样式 */
  .wechat-qr {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  background: white;
  padding: 3px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(46, 139, 87, 0.8);
  width: 106px;
  height: 106px;
  display: flex;
  align-items: center;
  justify-content: center;
  }

  .qr-image {
    width: auto;
    height: auto;
    max-width: 100px;
    max-height: 100px;
    display: block;
    object-fit: contain;
    background: white;
  }

  .concept-text {
    font-size: 0.9rem;
    padding: 0.25rem 0.8rem;
    letter-spacing: 0.2px;
  }

  .separator {
    margin: 1rem auto 0 auto;
  }

  .beian-section {
    padding: 0 0 0.2rem 0;
  }

  .beian-link {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
    gap: 0.3rem;
  }

  .copyright-section {
    padding: 0.2rem 0 0.5rem 0;
  }

  .copyright-text {
    font-size: 0.75rem;
    letter-spacing: 0.2px;
  }
}
</style>
